import { Helmet } from "react-helmet-async"
import { HotelBookings } from "../../../../Hotels/Item"
import { useParams } from "../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { useOutletContext } from "react-router"
import { IHotel } from "../../../../Hotels"

export default function HotelBookingsPage() {
	const { hotelId } = useParams("/hotels/:hotelId")
	const { hotel } = useOutletContext<{
		hotel: IHotel
	}>()
	return (
		<>
			<Helmet>
				<title>Bookings | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized
				anyPermissions={[
					PERMISSIONS.VIEW_HOTEL_BOOKINGS,
					PERMISSIONS.MANAGE_ACCOUNTING,
				]}
			>
				<HotelBookings
					params={{
						hotels: [Number(hotelId)],
						booking_suppliers: hotel.suppliers,
						direct_bookings_exists: hotel.direct_hotel_booking_exists,
					}}
				/>
			</ForbidUnlessAuthorized>
		</>
	)
}
